// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { Fragment } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
/* Starter Custom Code - End */

interface Props {
    categories: AutocompleteItemModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteCategoriesStyles;
}

export interface AutocompleteCategoriesStyles {
    headerText?: TypographyPresentationProps;
    categoryItemText?: TypographyPresentationProps;
    focusedCategoryItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    // Starter Custom Code
    note?: TypographyPresentationProps;
}

export const autocompleteCategoriesStyles: AutocompleteCategoriesStyles = {
    headerText: autocompleteProps.headerText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    note: autocompleteProps.note,
};

const styles = autocompleteCategoriesStyles;

class AutocompleteCategories extends React.Component<Props> {
    private readonly styles: AutocompleteCategoriesStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    render() {
        const { categories } = this.props;
        if (!categories || categories.length === 0) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteCategories_Header"
                    className="autocomplete-categories-header"
                >
                    {translate("Categories")}
                </Typography>
                {/* Starter Custom Code - Start */}
                <ul>
                    {categories.map(category => (
                        <li key={`${category.id}`}>
                            <Link
                                {...(this.props.focusedItem === category ? styles.focusedLink : styles.link)}
                                onClick={() => {
                                    this.props.goToUrl(category.url);
                                }}
                                className="autocomplete-categories-link"
                            >
                                {category.displayTitle}
                                {category.displaySubtitle ? (
                                    <Typography {...styles.note} className="autocomplete-categories-note">
                                        <>{` ${translate("in")}`}</> {category.displaySubtitle}
                                    </Typography>
                                ) : null}
                            </Link>
                        </li>
                    ))}
                </ul>
                {/* Starter Custom Code - End */}
            </>
        );
    }
}

export default AutocompleteCategories;
